import {alpha} from "@mui/material/styles";
import {
    assorted,
    black,
    blue,
    brand,
    green,
    gs75,
    neutral,
    orange,
    red,
    v64,
    v65,
    v75,
    v86,
    white,
    daily5,
    big9,
    race,
} from "../../tokens";
import type {CoreColor} from "../../types";

export const light: CoreColor = {
    text: {
        default: neutral[70],
        subtle: neutral[60],
        subtlest: neutral[50],
        accent: brand.accent,
        interactive: blue[60],
        disabled: neutral[40],
        information: blue[80],
        success: green[80],
        critical: red[80],
        attention: orange[80],
        inverted: {
            default: white[100],
            subtle: white[80],
            disabled: white[20],
        },
    },
    fill: {
        gametype: {
            assorted: {
                strong: "#1E89D2",
                default: assorted.default,
                subtle: assorted.subtle,
            },
            v75: {
                default: v75.default,
                subtle: v75.subtle,
                strong: v75.strong,
            },
            v86: {
                default: v86.default,
                subtle: v86.subtle,
                strong: v86.strong,
            },
            gs75: {
                default: gs75.default,
                subtle: gs75.subtle,
                strong: gs75.strong,
            },
            v64: {
                default: v64.default,
                subtle: v64.subtle,
                strong: v64.strong,
            },
            v65: {
                default: v65.default,
                subtle: v65.subtle,
                strong: v65.strong,
            },
            big9: {
                default: big9.default,
                subtle: big9.subtle,
                strong: big9.strong,
            },
            daily5: {
                default: daily5.default,
                subtle: daily5.subtle,
                strong: daily5.strong,
            },
        },
        canvas: "#F5F7FA",
        surface: {
            default: white[100],
            inverted: neutral[90],
        },
        neutral: {
            default: neutral["20A"],
            subtle: neutral["10A"],
            strong: neutral[30],
            inverted: {
                default: white[10],
                subtle: white["10A"],
            },
        },
        brand: {
            "responsible-gambling": {
                default: "#538E47",
                subtle: "#6EA840",
            },
            default: brand.default,
            subtle: "brand.subtle",
            strong: "brand.strong",
        },
        information: {
            default: blue[10],
            strong: blue[70],
        },
        success: {
            default: green[40],
            strong: green[70],
        },
        critical: {
            default: red[30],
            strong: red[60],
        },
        attention: {
            default: orange[30],
            strong: orange[70],
        },
        skeleton: {
            default: neutral["10A"],
            inverted: white["10A"],
        },
        accent: {
            default: brand.accent,
        },
        race,
    },
    icon: {
        default: neutral[70],
        subtle: neutral[60],
        subtlest: neutral[50],
        interactive: blue[60],
        disabled: neutral[40],
        critical: red[60],
        success: green[70],
        attention: orange[70],
        information: blue[80],
        selected: blue[60],
        inverted: {
            default: white[100],
            subtle: white[80],
        },
    },
    border: {
        default: black[30],
        subtle: black[10],
        strong: black[60],
        disabled: neutral["20A"],
        interactive: blue[60],
        focused: blue[50],
        success: green[70],
        information: blue[60],
        critical: red[60],
        attention: orange[70],
        inverted: {
            default: white[80],
            subtle: white[30],
            strong: white[100],
        },
    },
    interaction: {
        hovered: neutral["10A"],
        hoveredOpacity: 0.03,
        pressed: neutral["20A"],
        pressedOpacity: 0.06,
        disabled: white["10A"],
        disabledOpacity: 0.04,
        strong: {
            hovered: neutral["20A"],
            hoveredOpacity: 0.06,
            pressed: neutral["40A"],
            pressedOpacity: 0.36,
        },
        inverted: {
            hovered: white["20A"],
            hoveredOpacity: 0.08,
            pressed: black["20A"],
            pressedOpacity: 0.08,
            disabled: black["10A"],
            disabledOpacity: 0.04,
        },
    },
    button: {
        disabled: "rgba(158, 174, 189, 0.2)",
        primary: {
            default: green[80],
            critical: red[60],
            inverted: {
                default: green[80],
                critical: red[60],
            },
        },
        secondary: {
            default: "rgba(200, 228, 249, 0.28)",
            critical: alpha(red[60], 0.08),
            inverted: {
                default: white[30],
                critical: alpha(red[60], 0.08),
            },
        },
    },
    divider: {
        default: black["20A"],
        inverted: white["20A"],
    },
    backdrop: black[50],
    shadows: {
        surface: {
            default: {
                sharp: black["10A"],
                ambient: black["20A"],
            },
            strong: {
                sharp: black["20A"],
                ambient: alpha(black[100], 0.15),
            },
        },
    },
};
